import { useEffect, useState } from "react";
import { ptBR } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { CHALETS } from "@/lib/data";
import { brl, isPeak } from "@/lib/pricing";

const useMonths = () => {
  const [n, setN] = useState(2);
  useEffect(() => {
    const f = () => setN(window.innerWidth < 900 ? 1 : 2);
    f();
    window.addEventListener("resize", f);
    return () => window.removeEventListener("resize", f);
  }, []);
  return n;
};

export const ChaletPicker = ({ chaletId, setChaletId }) => (
  <div className="grid gap-3 sm:grid-cols-2">
    {CHALETS.map((c) => {
      const on = c.id === chaletId;
      return (
        <button
          key={c.id}
          type="button"
          data-testid={`chalet-select-${c.id}`}
          onClick={() => setChaletId(c.id)}
          className={`group flex items-center gap-4 rounded-sm border p-3 text-left transition-[border-color,background-color,box-shadow] duration-300 ${
            on ? "border-[#163323] bg-white shadow-[0_10px_30px_-12px_rgba(22,51,35,0.35)]" : "border-[#e2ded6] bg-white/60 hover:border-[#163323]/50"
          }`}
        >
          <img src={c.images[0]} alt={c.name} className="h-16 w-20 flex-none rounded-sm object-cover" />
          <div className="flex-1">
            <p className="font-bold uppercase tracking-tight text-[#163323]">{c.name}</p>
            <p className="text-sm text-[#5a6e61]">{brl(c.price)} / diária</p>
          </div>
          <span className={`h-5 w-5 flex-none rounded-full border-2 transition-colors ${on ? "border-[#163323] bg-[#163323] shadow-[inset_0_0_0_3px_#fff]" : "border-[#c9c2b4]"}`} />
        </button>
      );
    })}
  </div>
);

export const DateStep = ({ range, setRange }) => {
  const months = useMonths();
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return (
    <div data-testid="booking-date-picker" className="rounded-sm border border-[#e2ded6] bg-white p-2 sm:p-4" data-lenis-prevent>
      <Calendar
        mode="range"
        locale={ptBR}
        numberOfMonths={months}
        selected={range}
        onSelect={setRange}
        disabled={{ before: today }}
        fromMonth={today}
        showOutsideDays={false}
        modifiers={{ peak: isPeak }}
        modifiersClassNames={{ peak: "rm-peak" }}
        className="w-full p-1"
        classNames={{
          months: "flex flex-col md:flex-row gap-8 justify-center",
          month: "space-y-4 w-full",
          caption_label: "text-sm font-bold uppercase tracking-[0.2em] text-[#163323] capitalize",
          head_row: "flex justify-between",
          head_cell: "text-[#5a6e61] w-full font-bold text-[0.7rem] uppercase",
          row: "flex w-full mt-1 justify-between",
          cell: "relative w-full p-0 text-center text-sm focus-within:z-20 [&:has([aria-selected])]:bg-[#efe7da] [&:has(>.day-range-end)]:rounded-r-full [&:has(>.day-range-start)]:rounded-l-full",
          day: "h-11 w-full rounded-full p-0 font-normal text-[#1a241e] transition-colors hover:bg-[#e9c9a8]/60 aria-selected:opacity-100",
          day_selected: "!bg-[#163323] !text-[#faf7f2] hover:!bg-[#163323] focus:!bg-[#163323]",
          day_range_middle: "aria-selected:!bg-transparent aria-selected:!text-[#163323]",
          day_today: "font-bold underline underline-offset-4",
          day_disabled: "text-[#b9b3a8] opacity-60 hover:bg-transparent",
        }}
      />
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-[#efe9df] px-2 pt-3 text-xs text-[#5a6e61]">
        <span className="flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-[#c86d4b]" /> Datas especiais (24/12, 25/12, 31/12 e 01/01): + R$ 500,00 por diária
        </span>
      </div>
    </div>
  );
};
